import type { Component } from 'solid-js'
import type { ChurnData } from '../../../features/revenue/domain/models/churn'
import { ChartContainer, useChart } from '../charts'
import { getChurnChartOptions } from './ChurnChart.vm'

interface ChurnChartProps {
  data: ChurnData[]
  formatCategory?: (dateStr: string) => string
}

const ChurnChart: Component<ChurnChartProps> = (props) => {
  let chartRef: HTMLDivElement | undefined

  useChart({
    data: () => props.data,
    chartRef: () => chartRef,
    buildOptions: (data) => {
      const dataType = data[0]?.data_type
      return getChurnChartOptions(data, dataType, props.formatCategory)
    }
  })

  return (
    <ChartContainer hasData={props.data && props.data.length > 0}>
      <div ref={chartRef} />
    </ChartContainer>
  )
}

export default ChurnChart
